import React, { useState, useEffect } from 'react';
import { getCompanyInfo, saveCompanyInfo } from '../../data/supplierDocuments';

export default function CompanyInfoCard() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [info, setInfo] = useState({
    name: '',
    address: '',
    phone: '',
    email: '',
    siret: '',
    tva: ''
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    const data = getCompanyInfo();
    if (data) {
      setInfo(data);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInfo(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    saveCompanyInfo(info);
    setMessage('Informations de l\'entreprise enregistrées avec succès.');
    setTimeout(() => setMessage(''), 3000);
    setIsExpanded(false);
  };

  if (!isExpanded) {
    return (
      <div className="mb-3">
        <button className="btn btn-link p-0" onClick={() => setIsExpanded(true)}>
          📋 Modifier les infos entreprise
        </button>
      </div>
    );
  }

  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-header bg-light d-flex justify-content-between align-items-center">
        <h5 className="mb-0">📋 Informations Entreprise (ALMOUNE)</h5>
        <button className="btn-close" onClick={() => setIsExpanded(false)}></button>
      </div>
      <div className="card-body">
        {message && <div className="alert alert-success">{message}</div>}
        <form onSubmit={handleSave}>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Nom de l'entreprise</label>
              <input type="text" className="form-control" name="name" value={info.name} onChange={handleChange} required />
            </div>
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" name="email" value={info.email} onChange={handleChange} />
            </div>
            <div className="col-md-12">
              <label className="form-label">Adresse</label>
              <input type="text" className="form-control" name="address" value={info.address} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Téléphone</label>
              <input type="tel" className="form-control" name="phone" value={info.phone} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">SIRET</label>
              <input type="text" className="form-control" name="siret" value={info.siret} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">N° TVA Intracommunautaire</label>
              <input type="text" className="form-control" name="tva" value={info.tva} onChange={handleChange} />
            </div>
          </div>
          <div className="mt-3 text-end">
            <button type="button" className="btn btn-secondary me-2" onClick={() => setIsExpanded(false)}>Annuler</button>
            <button type="submit" className="btn btn-primary">Enregistrer</button>
          </div>
        </form>
      </div>
    </div>
  );
}
